module.exports = __webpack_public_path__ + "img/Logout.331e08d3.svg";